// extracted by mini-css-extract-plugin
export default {"ownerCell":"w5KPiFtPbE9K3NqtCGSw"};